module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/72aa95ab24a5871c58624e4f045b6cad.png";